import mapping from './mapping.json';


const regex_uuid = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;


export const addAwsDomain = path => `${mapping.aws_url}${path}`;

// capitalize string
export const cap = string => (typeof string === 'string' && string.length > 1
    ? `${string[0].toUpperCase()}${string.substring(1)}`
    : string);


// Format prop like string (show_impact_meter) to capitalized spaced words (Show Impact Meter)
export const fmt = field => (field
    ? field.split('_').map(word => cap(word)).join(' ')
    : field);

export const singleize = str => (str ? str.replace(/s$/, '') : str);

export const isImmutable = val => val && typeof val.toJS === 'function';

export const immutableToJS = val => (isImmutable(val) ? val.toJS() : val);

export const isUUID = val => val && regex_uuid.test(val);
